module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/hippa-pdf/hippa-pdf.component.scss
// module id = ./src/app/shared/components/hippa-pdf/hippa-pdf.component.scss
// module chunks = main